<div *ngIf="!showSecondFactor; else secondFactor">
	<h1>Ingresa a tu Cuenta</h1>
	<div class="tab-slider--nav">
		<ul class="tab-slider--tabs" [ngClass]="{ slide: !showTabDni }">
			<li class="tab-slider--trigger" [ngClass]="{ active: showTabDni }" rel="tab1" (click)="clickTab(true)">DNI</li>
			<li class="tab-slider--trigger" [ngClass]="{ active: showTabDni === false }" rel="tab2" (click)="clickTab(false)">
				Código de Socio
			</li>
		</ul>
	</div>
	<div id="tab1" class="tab-slider--body">
		<form #myform="ngForm">
			<div class="form_row clearfix">
				<div class="form_cell">
					<label>{{ showTabDni ? 'DNI:' : 'Código de socio:' }} </label>
					<span class="user_dni_codigo">
						<input
							type="text"
							numeric
							[ngClass]="{ val_error: validInputCode() }"
							class="form_element"
							[(ngModel)]="user.code"
							name="userCode"
							[placeholder]="showTabDni ? 'Ingrese número de DNI' : 'Ingrese su código de socio'"
							autocomplete="off"
							required
							[minlength]="showTabDni ? '8' : '3'"
							[maxlength]="showTabDni ? '8' : '7'"
							[disabled]="user.code?.includes('*') ?? false"
						/>
						<app-valid-message-form
							*ngIf="validInputCode()"
							[message]="messageErrorCode"
							type="error"
						></app-valid-message-form>
					</span>
				</div>
			</div>

			<label class="label_check open-modal"
				>Recuérdame
				<input type="checkbox" [(ngModel)]="isCheckedRemember" name="isCheckedRemember" (click)="clickRememberMe()" />
				<span class="checkmark"></span
			></label>

			<div class="form_row clearfix">
				<div class="form_cell">
					<label>Contraseña:</label>
					<span class="user_contrasena">
						<input
							[type]="typeInputPassword"
							[ngClass]="{ val_error: validateInputPassword() }"
							class="form_element"
							[(ngModel)]="user.password"
							name="userPassword"
							placeholder="Ingrese su contraseña"
							[minlength]="6"
							[maxlength]="10"
							required
						/>
						<!-- <a (click)="changeInput()" class="ver_password"></a> -->
						<app-valid-message-form
							*ngIf="validateInputPassword()"
							[message]="messageErrorPassword"
							type="error"
						></app-valid-message-form>
					</span>
				</div>
			</div>

			<div class="olvide_clave clearfix">
				<div>
					<a class="btn_olvide_pass" [routerLink]="['/recoveryPassword']">Desbloqueo de usuario</a>
					<br />
					<a class="btn_olvide_pass" [routerLink]="['/recoveryPassword']">Olvidé mi contraseña</a>
				</div>
				<a class="btn_solicitar_pass" [routerLink]="['/requestPassword']">Solicitar Contraseña</a>
			</div>
			<div class="center_content content_capcha">
				<!-- <img src="assets/images/capcha.png" alt="capcha" /> -->
			</div>
			<div id="alert"></div>
			<div class="center_content">
				<button type="submit" class="boton_ingresar" [disabled]="myform.invalid" (click)="clickLogin()">
					Ingresar
				</button>
			</div>

			<div class="center_content">
				<div class="cuenta_nueva">
					No tengo código,
					<a href="https://inscripciones.cp.com.pe/?utm_source=web_pacinet&utm_medium=boton" target="_blank"
						>Hazte socio aquí.</a
					>
				</div>
			</div>
		</form>
	</div>
</div>
<ng-template #secondFactor>
	<form #mySecondFactorform="ngForm">
		<br />
		<h1>Ingreso Con Segundo Factor</h1>
		<br />
		<div class="tab-slider--container">
			<div class="usuario_contrasena center_content">
				<label class="codigo_de_socio">Estimado socio ingrese la clave que llegó a su celular.</label>
				<app-alert
					*ngIf="messageErrorTokenResult !== ''"
					title="Error"
					[message]="messageErrorTokenResult"
					type="warn-ligth"
				>
				</app-alert>
				<div class="form_row clearfix dni_ruc_input">
					<div class="form_cell">
						<label style="text-align: left !important">Clave:</label>
						<span class="user_dni_codigo">
							<input
								numeric
								class="form_element"
								type="text"
								[(ngModel)]="tokenCode"
								[ngClass]="{ val_error: validTokenCode() }"
								name="tokenCode"
								[maxlength]="10"
								placeholder="Ingrese su clave"
								autocomplete="off"
								required
							/>
						</span>
						<app-valid-message-form
							*ngIf="validTokenCode()"
							[message]="messageErrorTokenCode"
							type="error"
						></app-valid-message-form>
					</div>
				</div>
				<div class="center_content">
					<button
						type="submit"
						class="boton_ingresar enviar_clave"
						[disabled]="mySecondFactorform.invalid"
						(click)="sendToken()"
					>
						ENVIAR
					</button>
				</div>
			</div>
			<div class="revisar_correo">
				<div class="center_content no_recibi_correo">
					<a (click)="backToLogin()" class="volver_enviar">Regresar al login</a>
				</div>
			</div>
		</div>
	</form>
</ng-template>
